import { createSelector } from "reselect";

const getRegionFilter = state => state.advisor.region;
const getRegions = state => state.regions.data;

const selectRegion = createSelector(
  [getRegionFilter, getRegions],
  (regionId, regions) => {
    return regions.find(region => region.id === regionId);
  }
);

export default selectRegion;
